export const CHANGE_SLIDE_ITEM = 'CHANGE_SLIDE_ITEM';
export const RESET_BANNER = 'RESET_BANNER';
export const VALIDATE_BANNER = 'VALIDATE_BANNER';
